import { useNavigate } from 'react-router-dom'
import { Row, Col } from 'react-bootstrap'
import { IPageProps, } from 'types'
import { PageHeader, ReturnButton } from 'components'

const DealersAddPage = ({ title }: IPageProps) => {

    return (
        <div id='DealersAddPage'>
            <PageHeader title={title}>
                <ReturnButton redirectUrl='/dealers' />
            </PageHeader>

            <Row>
                <Col>
                    <span className='test'>Add Page Here</span>
                </Col>
            </Row>
        </div>
    )
}
export default DealersAddPage
